import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Card,
  TextField,
  Typography,
  Stack,
  Container,
} from '@mui/material';

interface ClinicLinkInputFormProps {
  validUrl: string;
  loading: boolean | null;
  onLinkSubmit: (link: string) => void;
}

export const ClinicLinkInputForm: React.FC<ClinicLinkInputFormProps> = ({
  validUrl,
  loading,
  onLinkSubmit,
}) => {
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    if (validUrl) {
      setInputValue(validUrl);
    }
  }, [validUrl]);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onLinkSubmit(inputValue);
  };

  return (
    <Container maxWidth="md">
      <Card
        component="form"
        onSubmit={handleSubmit}
        sx={{
          p: 4,
          my: 2,
          backgroundColor: '#f9f9f9',
        }}
      >
        <Stack spacing={3}>
          <Box>
            <TextField
              fullWidth
              label="Clinic Link"
              type="text"
              placeholder="Enter clinic waiting area link"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value.split('?')[0])}
              required
              variant="outlined"
              helperText="Copy and paste the link from the waiting area dashboard"
            />
          </Box>

          <Box>
            <Typography variant="body2" sx={{ mb: 2 }}>
              Copy and paste the link from the waiting area dashboard under "Share the link to your
              waiting area". This will look like one of these examples:
            </Typography>
            <Box component="ul" sx={{ pl: 2 }}>
              <Box component="li" sx={{ mb: 1 }}>
                <Typography variant="body2" sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                  https://vcc.healthdirect.org.au/t/acmehealth1/join
                </Typography>
              </Box>
              <Box component="li" sx={{ mb: 1 }}>
                <Typography variant="body2" sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>https://videocall.direct/acme</Typography>
              </Box>
              <Box component="li" sx={{ mb: 1 }}>
                <Typography variant="body2" sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                  https://vcc.healthdirect.org.au/t/acmehealth1/team/waiting-area
                </Typography>
              </Box>
            </Box>
          </Box>

          <Button
            type="submit"
            variant="contained"
            color="primary"
            loading={loading}
            sx={{ alignSelf: 'flex-start', mt: 2 }}
          >
            Continue
          </Button>
        </Stack>
      </Card>
    </Container>
  );
};

export default ClinicLinkInputForm;
